<template>
    <div class="transition-all duration-100 ease-linear custom-left py-[16px]">
        <div class="flex xl:flex-row flex-col justify-between p-[16px]">
            <h2 class="text-[24px] font-semibold text-white">Customer Export Log</h2>
        </div>

        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl">
            <div class="pt-3 bg-[#2B2C32] px-[16px] rounded-xl">
                <new-table-lite 
                    :class="'block w-full min-h-[480px] admin-table '"
                    :is-loading="table.loading"
                    :is-slot-mode="true"
                    :columns="table.columns"
                    :rows="table.rows"
                    :total="table.totalRecords"
                    :sortable="table.sortable"
                    :page="table.page"
                    :page-size="table.pagesize"
                    @do-search="doSearch"
                    :messages="{
                        pagingInfo: 'Total: {2}',
                        pageSizeChangeLabel: 'Items per Page',
                        gotoPageLabel: 'Go to page',
                        noDataAvailable: 'No records found!',
                    }"
                >
                    <template v-slot:createdAt="data">
                        <span>{{canadaTime(data.value.createdAt)}}</span>
                    </template>
                </new-table-lite>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, defineComponent } from 'vue'
import { useSnackbar } from "vue3-snackbar";
import NewTableLite from '@/components/table/tableLite.vue'
import UserCustomerApis from '@/controllers/UserCustomerApis';
import moment from 'moment-timezone'
import {mapGetters} from 'vuex'
import Env from '@/env';
import Helpers from '@/helpers';

export default defineComponent({
    components: {
        NewTableLite
    },
    setup() {
        const snackbar = useSnackbar();
        const currentVariant = ref({})
        const table = reactive({
            loading: false,
            columns: [
                {label: 'Date & time', field:'createdAt', sortable: true, isKey: false},
                {label: 'Name', field:'exportedByFirstName', sortable:false},
                {label: 'Email', field: 'exportedByEmail', sortable: false},
            ],
            rows: [],
            totalRecords: 0,
            page: 1,
            pagesize: Env.defaultPageSize,
            pageOptions: Env.pageList,
            sortable: {
                order: "",
                sort: "",
            },
        })
        return {snackbar, currentVariant, table}
    },
    mounted(){
        this.getData()
    },
    computed:{
        ...mapGetters({
            vg_selectedLocation: 'location/selected',
            vg_selectedBusiness: 'auth/activeBusiness'
        })
    },
    methods: {
        canadaTime(data){
            if(!data) return
            let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
            return moment(data).tz(defaultTimeZone).format('YYYY-MM-DD h:mm a');
        },
        async getData(){
            this.table.loading = true
            let params = `page=${this.table.page}&perPage=${this.table.pagesize}`
            if(this.table.sortable.order && this.table.sortable.sort){
                params += `&sort=${this.table.sortable.sort}&order=${this.table.sortable.order}`
            }
            let res = await UserCustomerApis.customerExportLog(this.vg_selectedBusiness.id, params)
            if(res.status==200){
                this.table.rows = res.data.payload.logs
                this.table.totalRecords = res.data.payload.totalRecords
            }else{
                this.table.rows = []
                this.table.totalRecords = 0
            }
            if(res.status !== 200){
                this.snackbar.add({
                    type: 'info',
                    text: Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
            }
            this.table.loading = false
        },
        doSearch(offset, limit, sort, order) {
            let page = (offset/limit)+1
            this.table.pagesize = limit;
            this.table.page = page;
            this.table.sortable.order = order;
            this.table.sortable.sort = sort;
            this.getData();
        },
    }
})
</script>